export const replaceTag = (str) => {
  let result = str.replace(/(<([^>]+)>)/gi, '');
  
  return result;
}